/*
    Burger Menu Trigger
*/

export default class BurgerController {
    constructor(options = {}) {
        const defaultOptions = {
            menuClass: '.js-submenu',
            triggerClass: '.js-submenu-trigger',
            menuCloseClass: '.js-submenu-close'
        }

        this.options = {...defaultOptions, ...options};

        this.init();
    }

    init() { 
        const menuEl = document.querySelector(this.options.menuClass);
        const triggerEl = document.querySelector(this.options.triggerClass);
        const menuCloseEl = document.querySelectorAll(this.options.menuCloseClass);
        const body = document.querySelector('body');

        if (!menuEl || !triggerEl) {
            console.error("Can't find burger menu required elements");
            return;
        }

        triggerEl.addEventListener("click", (e) => {
            e.currentTarget.classList.toggle('active');
            menuEl.classList.toggle('active');
            body.classList.toggle('active');
        });

        for(let el of menuCloseEl) {
            el.addEventListener("click", (e) => {
                e.target.classList.remove('active');
                menuEl.classList.remove('active');
                body.classList.remove('active');
                triggerEl.classList.remove('active');
            });
        }

        //Close by escape
        document.addEventListener("keydown", (e) => {
            if(e.key === "Escape") {
                triggerEl.classList.remove('active');
                menuEl.classList.remove('active');
                body.classList.remove('active');
            }
        });
    }
}